const URL = `https://chat.sooqdev2.com`;
const io = require('socket.io-client');
export default (url) => {
    return io(url, {
        'reconnection': true,
        'reconnectionDelay': 500,
        'reconnectionAttempts': 10
    });
};
